module.exports = __webpack_public_path__ + "static/Enchante (4)-04a504337fcfbb3145f86cd0829c05eb.jpeg";